<template>
<div>
    <v-card flat outlined v-if="loaded">
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="6" md="8">
                    <div class="headline font-weight-light">
                        <span v-if="kind=='all'">All groups</span>
                        <span v-if="kind=='center'">Groups</span>
                    </div>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                    <div class="text-right">
                        <v-btn depressed class="accent" @click="$router.push('/admin-groups/add?ct='+center)" v-if="kind=='center'">New group</v-btn>
                        <v-btn depressed class="accent" @click="$router.push('/admin-groups/add')" v-if="kind=='all'">New group</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>

        <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="25"
            no-data-text="No groups registered.">
            <template v-slot:item.group="{ item }">
                <div>{{item.str}}</div>
                <div class="caption grey--text text--darken-2">{{item.reference}}</div>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon small color="light-blue" class="mr-6" @click="$router.push('/admin-group/'+item.id+'?ct='+item.center.id)">fa-link</v-icon>
                <v-icon small color="grey" class="mr-4">fa-pen</v-icon>
            </template>
        </v-data-table>
    </v-card>

    <SendingLoader v-else/>
</div>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Groups from '@/firebase/groups'
import Schedules from '@/firebase/schedules'

export default {
    data: () => ({
        loaded: false,
        items: [],
        headers: [
            {   text: 'Group', 
                value: 'group' 
            },
            {   text: 'Center', 
                value: 'center.name' 
            },
            { 
                text: 'Actions', 
                align: 'right',
                value: 'action' 
            }
        ],
        search: '',
    }),
    props: ['kind', 'center'],
    mounted() {
        this.setHeaders();
        this.init();
    },
    methods: {
        setHeaders() {
            if (this.kind == 'center') {
                this.headers = [
                    {   text: 'Group', 
                        value: 'str' 
                    },
                    {   text: 'Generation', 
                        value: 'reference' 
                    },
                    { 
                        text: 'Actions', 
                        align: 'right',
                        value: 'action' 
                    }
                ]
            }
        },
        init() {
            this.loaded = false;
            this.items = [];

            if (this.kind == 'all') {
                Groups.getAll()
                    .then(response => {
                        if (response.status === true) {
                            this.items = Helpers.formatItems(response.query);
                            this.formatSchedules();
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
            }

            if (this.kind == 'center') {
                Groups.getByCenter(this.center)
                    .then(response => {
                        if (response.status === true) {
                            this.items = Helpers.formatItems(response.query);
                            this.formatSchedules();
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
            }
            
        },
        formatSchedules(gr) {
            this.items.forEach(dt => {
                dt.str = dt.day + ' / ' + dt.hour;
            });
        }
    }
}
</script>